import get from "lodash/get";
import withStyles from "@material-ui/core/styles/withStyles";
import DynamicForm from "Component/DynamicForm";
import IconWithBackground from "Component/Icons/iconWithBackground";
import { withSnackbar } from "notistack";
import React from "react";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import moment from "moment";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Paper from "@material-ui/core/Paper";
import previewIcon from "Assets/newicons/user-interface/eye-show/outline/eye-show-outline-16px.svg";
import SectionHeaderExtraSmall from "Component/Headers/sectionHeaderExtraSmall";
import DrawerHeader from "Component/Headers/drawerHeader";
import Drawer from "@material-ui/core/Drawer";
import SearchSq from "Component/Material-ui/SearchSq";
import bankillustration from "Assets/Svg/bank-illustration.svg";
import IciciIcon from "Assets/Svg/ICICI_Bank_Logo.svg";
import ProfilePictureSmall from "Component/Thumbnail/ProfilePictureSmall";
import DefaultProfileImage from "Assets/Images/profile_defaultImg.svg";
import Switch from "@material-ui/core/Switch";
import loader from "Assets/Gif/loader.gif";
import classNames from "classnames";
import {
  setSaveProgress,
  removeSaveProgress,
} from "Actions/SaveProgressAction";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import { instance } from "Actions/AxiosInstance";
import { getOptArr } from "Utils/arr";
import { getMonthName } from "Utils";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import { multiselectinputconverter } from "Component/DynamicForm/Fields/MultiSelect";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import Select from "react-select";
import { convertDateForBackend } from "Utils";

const styles = () => ({
  drawerPaper: {
    width: 356,
  },
});

export const ExportArrearsXLSX = (props = {}) => {
  const { rows = [], name = "" } = props;
  const filename = `Bank_Sheet_${getMonthName(name.split("-")[0])}_${
    name.split("-")[1]
  }.xlsx`;
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const headers = [
    "employeecode",
    "employeename",
    "locationname",
    "accountnumber",
    "bankname",
    "branchname",
    "ifsccode",
    "paymentmethod",
    "hold",
    "totalnetamount",
  ];
  const ws = XLSX.utils.json_to_sheet([...rows], {
    header: headers,
    skipHeader: true,
  });
  /* hide employeeid column */
  // ws["!cols"] = [];
  // ws["!cols"][7] = { hidden: true };
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, filename);
};

export const ExportArrearsXLSX1 = (props = {}) => {
  const { rows = [], name = "" } = props;
  const filename = `Bank_Sheet_${getMonthName(name.split("-")[0])}_${
    name.split("-")[1]
  }.xlsx`;
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const headers = [
    "paymenttypecode",
    "paymentmode",
    "debitaccnumber",
    "employeename",
    "accountnumber",
    "ifsccode",
    "totalnetamount",
    "debitnarr",
    "creditnarr",
    "mobile",
    "emailid",
    "remark",
    "paymentdate",
    "refno",
    "addlinfo1",
    "addlinfo2",
    "addlinfo3",
    "addlinfo4",
    "addlinfo5"
  ];
  const ws = XLSX.utils.json_to_sheet([...rows], {
    header: headers,
    skipHeader: true,
  });
  /* hide employeeid column */
  // ws["!cols"] = [];
  // ws["!cols"][7] = { hidden: true };
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, filename);
};

class RunPayrollTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isloading: false,
      isgeneratedrawerloading: false,
      isgeneratepayslipdrawerloading: false,
      time: 0,
      value: 0,
      banksheetdrawer: false,
      taxsheetdata: false,
      searchemployeeValue: null,
      isDataGenerated: false,
      generatedBoth: false,
      SignatoryDrawer: false,
      islwfdeduction: null,
      employeeselected: false,
      searchedemplist: [],
      employeelist: [],
      open: false,
      sentnotification: false,
      isgenerate: "",
      payrollgroup: [],
      backuplistdata: [],
      newemployeelist: [],
      datacategories: [
        { displayvalue: "1", displayname: "All" },
        { displayvalue: "2", displayname: "Data Generated" },
        { displayvalue: "3", displayname: "Non Data Generated" },
      ],
      selecteddatatypeid: "1",
      datatypeid: { displayvalue: "1", displayname: "All" },
    };

    this.addSignatoryDrawer = this.addSignatoryDrawer.bind(this);
    this.CloseSignatoryDrawer = this.CloseSignatoryDrawer.bind(this);
    this.setSelectedEmployees = this.setSelectedEmployees.bind(this);
    // this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {}

  setSelectedEmployees(selectedItems) {
    this.props.updateSelection({ selectedEmployees: selectedItems });
  }

  // addSignatoryDrawer() {
  //   this.setState({SignatoryDrawer: true}, () => this.getFinalEmployeeList() )

  // }

  addSignatoryDrawer() {
    this.getFinalEmployeeList();
  }

  getPayrollGroup = () => {
    const {
      selectedEmployees = [],
      selectedLoc = [],
      selectedDep = [],
      selectedBus = [],
      selectedEmpType = [],
    } = this.props;
    const { selectedOptions } = this.props;
    const payrollgroup = [];
    if (selectedOptions.length != 0) {
      selectedOptions.forEach((opt) => {
        const index = payrollgroup.findIndex(
          (x) => x.grouptypeid === opt.grouptypeid,
        );
        if (index == -1) {
          payrollgroup.push({
            grouptypeid: opt.grouptypeid,
            groupids:
              opt.grouptypeid === 1
                ? null
                : opt.grouptypeid === 0
                ? selectedEmployees
                  ? selectedEmployees.map((x) => x.displayvalue).join(",")
                  : ""
                : opt.grouptypeid === 2
                ? selectedBus
                  ? selectedBus.map((x) => x.businessunitid).join(",")
                  : ""
                : opt.grouptypeid === 3
                ? selectedDep
                  ? selectedDep.map((x) => x.departmentid).join(",")
                  : ""
                : opt.grouptypeid === 4
                ? selectedEmpType
                  ? selectedEmpType.map((x) => x.displayvalue).join(",")
                  : ""
                : opt.grouptypeid === 5
                ? selectedLoc
                  ? selectedLoc.map((x) => x.displayvalue).join(",")
                  : ""
                : [opt.displayvalue].join(","),
          });
        } else {
          payrollgroup[index].groupids =
            opt.grouptypeid === 1
              ? null
              : opt.grouptypeid === 0
              ? selectedEmployees
                ? selectedEmployees.map((x) => x.displayvalue).join(",")
                : ""
              : opt.grouptypeid === 2
              ? selectedBus
                ? selectedBus.map((x) => x.businessunitid).join(",")
                : ""
              : opt.grouptypeid === 3
              ? selectedDep
                ? selectedDep.map((x) => x.departmentid).join(",")
                : ""
              : opt.grouptypeid === 4
              ? selectedEmpType
                ? selectedEmpType.map((x) => x.displayvalue).join(",")
                : ""
              : opt.grouptypeid === 5
              ? selectedLoc
                ? selectedLoc.map((x) => x.displayvalue).join(",")
                : ""
              : [opt.displayvalue].join(",");
        }
      });

      return payrollgroup;
    }
    return [];
  };

  ongeneratepayrollclick = (temp) => {
    if (this.props.isSpeicalCase && !this.state.isgenerate) {
      if (this.props.selectedOptions.length != 0) {
        // this.setState({ispayslipdrawer:false}, () => this.getSpecificEmps());
        this.getSpecificEmps();
      } else {
        this.props.enqueueSnackbar("Please select an option", {
          variant: "error",
        });
      }
    } else if (!this.props.isSpeicalCase && !this.state.isgenerate) {
      if (this.props.selectedOptions.length != 0) {
        this.getSpecificEmps();
        // this.setState({open:true}, () => this.getSpecificEmps())
      } else {
        this.props.enqueueSnackbar("Please select an option", {
          variant: "error",
        });
      }
    } else {
      const { payrollcycledurationid, salarycycle } = this.props;
      const { selectedOptions, isSpeicalCase } = this.props;
      if (selectedOptions.length != 0) {
        const payrollgroup = this.getPayrollGroup();
        const data = {
          payrollcycledurationid,
          salarycycleid: salarycycle.salarycycleid,
          salarycyclesplitid: salarycycle.displayvalue,
          grouptypeid: isSpeicalCase
            ? selectedOptions[0] && selectedOptions[0].displayvalue
            : selectedOptions[0] && selectedOptions[0].displayvalue == 100
            ? selectedOptions[0] && selectedOptions[0].displayvalue
            : null,
          payrollgroup,
          payrollmonthid:
            this.props.salarycycle && this.props.salarycycle.payrollmonthid,
          payrollyear:
            this.props.salarycycle && this.props.salarycycle.payrollyear,
        };
        if (
          data.payrollgroup &&
          data.payrollgroup.find((x) => x.grouptypeid == 0) &&
          data.payrollgroup.find((x) => !x.groupids)
        ) {
          this.props.enqueueSnackbar("Please select employees", {
            variant: "error",
          });
          this.setState({
            open: false,
            SignatoryDrawer: false,
          });
        } else {
          // if (this.props.isSpeicalCase) {
          console.log("temp: ", temp);
          if (temp && Array.isArray(temp)) {
            if (temp.find((emp) => emp.isexpanded)) {
              this.setState(
                {
                  open: false,
                  //isgenerate: false,
                },
                () => {
                  this.props.isSpeicalCase
                    ? this.props.updateSpecialEmps(temp)
                    : this.props.updateNormalEmps(temp);
                  this.props.setpostdataforemplist(data);
                },
              );
            } else {
              this.props.enqueueSnackbar("Please select atleast one employee", {
                variant: "error",
              });
            }
          }
          // }
        }
      } else {
        this.props.enqueueSnackbar("Please select atleast one option", {
          variant: "error",
        });
        this.setState({
          open: false,
          SignatoryDrawer: false,
        });
      }
    }
  };

  
  handleChange1(selectedItem) {
    const datatypeid = selectedItem;
    const selecteddatatypeid = selectedItem.displayvalue;
    this.setState(
      {
        datatypeid,
        selecteddatatypeid,

        //selectedBackupEmployeeid: selectedItem,
      },
      () => this.filtergeneratedlist1(selecteddatatypeid),
    );
  }

  filtergeneratedlist1(datatypeid) {
    if (datatypeid == "3") {
      const finalEmployeeList = this.state.tempdatalist.filter(
        (x) => !x.isdatagenerated,
      );
      this.setState({ finalEmployeeList });
    } else if (datatypeid == "2") {
      const finalEmployeeList = this.state.tempdatalist.filter(
        (x) => x.isdatagenerated,
      );
      this.setState({ finalEmployeeList });
    } else {
      const finalEmployeeList = this.state.tempdatalist;
      this.setState({ finalEmployeeList });
    }
  }

  

  onSyncSheet = (temp) => {
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    console.log("issaveinprogress: ", issaveinprogress);
    const {
      payrollcycledurationid,
      salarycycle,
      payrollcycles,
      payrollcyclestart,
      payrollcycleend,
    } = this.props;
    const { newemployeelist } = this.state;
    console.log("newemployeelist: ", newemployeelist);

    if (temp && Array.isArray(temp)) {
      if (temp.find((emp) => emp.isexpanded)) {
        console.log("temp: ", temp);
        // this.setState(
        //   {
        //     open: false,
        //     taxsheetdata: false,
        //   },
        //   () => {
        if (!issaveinprogress) {
          //  if (temp.length <= 20) {
          const totalseconds = temp.length * 3;
          const secondsforintervals = totalseconds * 1000;
          this.interval = setInterval(
            () =>
              this.setState({
                time: this.state.time >= 99 ? 99 : this.state.time + 1,
              }),
            secondsforintervals / 100,
          );
          this.setState(
            {
              time: 0,
              loading: true,
            },
            () => {
              this.props.setSaveProgress(true);
              instance
                .post("payroll/syncincometax", {
                  salarycycleid: salarycycle.salarycycleid,
                  employeeids: temp.map((x) => x.employeeid),
                  payrollcycledurationid,
                  payrollcyclestart,
                  payrollcycleend,
                })
                .then((resp) => {
                  clearInterval(this.interval);
                  this.props.enqueueSnackbar(
                    "Employee(s) taxsheet synchronized successfully",
                    { variant: "success" },
                  );
                  this.setState({
                    open: false,
                    taxsheetdata: false,
                    time: 100,
                    loading: false,
                  });
                  this.props.removeSaveProgress();
                })
                .catch((error) => {
                  // this.setState({ taxsheets: null, drcv: true });
                  this.props.removeSaveProgress();
                  this.setState(
                    {
                      time: 0,
                      loading: false,
                    },
                    () => {
                      clearInterval(this.interval);
                      this.props.enqueueSnackbar(
                        error.response
                          ? error.response.data.error.message
                          : error.message,
                        { variant: "error" },
                      );
                    },
                  );
                });
            },
          );
          // }
          //  else {
          //   this.props.enqueueSnackbar("You can select a maximum of 20 employees to re-run the tax sheet.", {
          //     variant: "error",
          //   });
          // }
        }
        //   },
        // );
      } else {
        this.props.enqueueSnackbar("Please select atleast one employee", {
          variant: "error",
        });
      }
    }
  };

  getFinalEmployeeList = () => {
    const { payrollcycledurationid, salarycycle } = this.props;
    const { selectedOptions, isSpeicalCase } = this.props;
    if (selectedOptions.length != 0) {
      const payrollgroup = this.getPayrollGroup();
      const data = {
        payrollcycledurationid,
        salarycycleid: salarycycle.salarycycleid,
        salarycyclesplitid: salarycycle.displayvalue,
        grouptypeid: isSpeicalCase
          ? selectedOptions[0] && selectedOptions[0].displayvalue
          : selectedOptions[0] && selectedOptions[0].displayvalue == 100
          ? selectedOptions[0] && selectedOptions[0].displayvalue
          : null,
        payrollgroup,
        payrollmonthid:
          this.props.salarycycle && this.props.salarycycle.payrollmonthid,
        payrollyear:
          this.props.salarycycle && this.props.salarycycle.payrollyear,
      };
      if (
        data.payrollgroup &&
        data.payrollgroup.find((x) => x.grouptypeid == 0) &&
        data.payrollgroup.find((x) => !x.groupids)
      ) {
        this.props.enqueueSnackbar("Please select employees", {
          variant: "error",
        });
      } else {
        this.setState({ isloading: true }, () =>
          instance
            .post("payroll/employeelist", data)
            .then((resp) => {
              if (
                get(resp, "data.result[0].employeelist", []).filter(
                  (x) => !x.ispayslipgenerated,
                ).length > 0
              ) {
                this.setState({
                  isloading: false,
                  SignatoryDrawer: true,
                  finalEmployeeList: get(
                    resp,
                    "data.result[0].employeelist",
                    [],
                  ).filter((x) => !x.ispayslipgenerated),
                  backuplistdata: get(
                    resp,
                    "data.result[0].employeelist",
                    [],
                  ).filter((x) => !x.ispayslipgenerated),
                });
              } else {
                this.setState({ isloading: false });
                this.props.enqueueSnackbar(
                  `${
                    salarycycle.ispayrolldone && !isSpeicalCase
                      ? "Payslip is already generated for selected employees"
                      : "No record found"
                  }`,
                  { variant: "error" },
                );
              }
            })
            .catch((error) => {
              this.setState({ isloading: false, SignatoryDrawer: false });
              this.props.enqueueSnackbar(
                error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
            }),
        );
      }
    } else {
      this.props.enqueueSnackbar("Please select atleast one option", {
        variant: "error",
      });
    }
  };

  getSpecificEmps = () => {
    const { payrollcycledurationid, salarycycle } = this.props;
    const { selectedOptions, isSpeicalCase } = this.props;
    if (selectedOptions.length != 0) {
      const payrollgroup = this.getPayrollGroup();
      const data = {
        payrollcycledurationid,
        salarycycleid: salarycycle.salarycycleid,
        salarycyclesplitid: salarycycle.displayvalue,
        grouptypeid: isSpeicalCase
          ? selectedOptions[0] && selectedOptions[0].displayvalue
          : selectedOptions[0] && selectedOptions[0].displayvalue == 100
          ? selectedOptions[0] && selectedOptions[0].displayvalue
          : null,
        payrollgroup,
        payrollmonthid:
          this.props.salarycycle && this.props.salarycycle.payrollmonthid,
        payrollyear:
          this.props.salarycycle && this.props.salarycycle.payrollyear,
      };
      if (
        data.payrollgroup &&
        data.payrollgroup.find((x) => x.grouptypeid == 0) &&
        data.payrollgroup.find((x) => !x.groupids)
      ) {
        this.props.enqueueSnackbar("Please select employees", {
          variant: "error",
        });
      } else {
        this.setState({ isgeneratedrawerloading: true }, () => {
          instance
            .post("payroll/employeelist", data)
            .then((resp) => {
              if (
                get(resp, "data.result[0].employeelist", []).filter(
                  (x) => !x.ispayslipgenerated,
                ).length > 0
              ) {
                this.setState({
                  open: true,
                  isgenerate: true,
                  isgeneratedrawerloading: false,
                  finalEmployeeList: get(
                    resp,
                    "data.result[0].employeelist",
                    [],
                  ).filter((x) => !x.ispayslipgenerated),
                  tempdatalist: get(
                    resp,
                    "data.result[0].employeelist",
                    [],
                  ).filter((x) => !x.ispayslipgenerated),
                });
              } else {
                this.setState({ isgeneratedrawerloading: false });
                this.props.enqueueSnackbar("No records found", {
                  variant: "error",
                });
              }
            })
            .catch((error) => {
              this.setState({ isgeneratedrawerloading: false });
              this.props.enqueueSnackbar(
                error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
            });
        });
      }
    } else {
      this.props.enqueueSnackbar("Please select atleast one option", {
        variant: "error",
      });
    }
  };

  handleStructureSearch = (e) => {
    const { backuplistdata } = this.state;
    const filterFormList = backuplistdata.filter(
      (item) =>
        // console.log('item: ', item)
        item.empfullname.toLowerCase().search(e.target.value.toLowerCase()) !==
        -1,
    );
    this.setState({
      searchemployeeValue: e.target.value,
      finalEmployeeList: e.target.value ? filterFormList : backuplistdata,
      newemployeelist: e.target.value ? filterFormList : backuplistdata,
    });
  };

  CloseSignatoryDrawer() {
    this.setState({
      SignatoryDrawer: false,
    });
  }

  download = () => {
    const { payrollcycle, salarycycle } = this.props;
    const { payrollcycledurationid } = this.props;
    const { selectedOptions, isSpeicalCase } = this.props;
    if (selectedOptions.length != 0) {
      const payrollgroup = this.getPayrollGroup();
      const data = {
        payrollcycledurationid,
        salarycycleid: salarycycle.salarycycleid,
        salarycyclesplitid: salarycycle.displayvalue,
        grouptypeid: isSpeicalCase
          ? selectedOptions[0] && selectedOptions[0].displayvalue
          : selectedOptions[0] && selectedOptions[0].displayvalue == 100
          ? selectedOptions[0] && selectedOptions[0].displayvalue
          : null,
        payrollgroup,
        payrollmonthid:
          this.props.salarycycle && this.props.salarycycle.payrollmonthid,
        payrollyear:
          this.props.salarycycle && this.props.salarycycle.payrollyear,
      };
      instance
        .post("payroll/employeelist", data)
        .then((resp) => {
          if (
            get(resp, "data.result[0].employeelist", []).find(
              (x) => x.isdatagenerated,
            )
          ) {
            instance
              .post("payroll/getemployeebanksheetdetails", {
                payrollcycledurationid: get(
                  payrollcycle,
                  "payrollcycledurationid",
                  12,
                ),
                salarycyclesplitid: get(salarycycle, "displayvalue", 12),
                salarycycleid: get(salarycycle, "salarycycleid", 12),
                payrollyear: get(salarycycle, "payrollyear", 12),
                payrollmonthid: get(salarycycle, "payrollmonthid", 12),
                employeeids: get(resp, "data.result[0].employeelist", [])
                  .filter((x) => x.isdatagenerated)
                  .map((x) => x.employeeid),
              })
              .then((resp1) => {
                if (
                  get(resp1, "data.result", []) &&
                  get(resp1, "data.result", []).length > 0
                ) {
                  console.log("resp: ", resp1);
                  const headerobj = {
                    employeecode: "Emp Code",
                    employeename: "Employee Name",
                    locationname: "Office Location",
                    accountnumber: "Bank Account Number",
                    bankname: "Bank Name",
                    branchname: "Branch Name",
                    ifsccode: "IFSC code",
                    paymentmethod: "Payment Method",
                    hold: "Hold Status",
                    totalnetamount: "Net Salary",
                  };

                  const allrows = [
                    headerobj,
                    ...get(resp1, "data.result", []).map((emp) => ({
                      employeecode: emp.employeecode,
                      employeename: emp.employeename,
                      locationname: emp.locationname,
                      accountnumber: emp.accountnumber,
                      bankname: emp.bankname,
                      branchname: emp.branchname,
                      ifsccode: emp.ifsccode,
                      paymentmethod: emp.paymentmethod,
                      hold: emp.hold,
                      totalnetamount: emp.totalnetamount,
                    })),
                  ];
                  ExportArrearsXLSX({
                    rows: allrows,
                    name: salarycycle && salarycycle.displayname,
                  });

                  const data = {
                    generationtypeid: 1,
                    reportcatagoryid: 4,
                    reporttypeid: 304,
                    reportfor: {
                      reportforlog: [
                        {
                          genaratefortypeid: 1,
                          genarateforids: null,
                          locationids: null,
                          stageids: "1,2,3,4,5,6,7,8",
                          reviewformids: null,
                          employmenttypeids: "1,2,3,4,5,6,7,8,9",
                        },
                      ],
                    },
                    fromdate: convertDateForBackend(
                      get(salarycycle, "cyclefrom", 12),
                    ),
                    todate: convertDateForBackend(
                      get(salarycycle, "cycleto", 12),
                    ),
                  };

                  instance.post("/reportrobo/reportrobolog", data);
                } else {
                  this.props.enqueueSnackbar("No record found", {
                    variant: "error",
                  });
                }
              })
              .catch((error) => {
                this.props.enqueueSnackbar(
                  error.response
                    ? error.response.data.error.message
                    : error.message,
                  { variant: "error" },
                );
              });
          } else {
            this.props.enqueueSnackbar("Bank data is not generated", {
              variant: "error",
            });
          }
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    } else {
      this.props.enqueueSnackbar("Please select atleast one option", {
        variant: "error",
      });
    }
  };

  downloadIcci = () => {
    const { payrollcycle, salarycycle } = this.props;
    const { payrollcycledurationid } = this.props;
    const { selectedOptions, isSpeicalCase } = this.props;
    if (selectedOptions.length != 0) {
      const payrollgroup = this.getPayrollGroup();
      const data = {
        payrollcycledurationid,
        salarycycleid: salarycycle.salarycycleid,
        salarycyclesplitid: salarycycle.displayvalue,
        grouptypeid: isSpeicalCase
          ? selectedOptions[0] && selectedOptions[0].displayvalue
          : selectedOptions[0] && selectedOptions[0].displayvalue == 100
          ? selectedOptions[0] && selectedOptions[0].displayvalue
          : null,
        payrollgroup,
        payrollmonthid:
          this.props.salarycycle && this.props.salarycycle.payrollmonthid,
        payrollyear:
          this.props.salarycycle && this.props.salarycycle.payrollyear,
      };
      instance
        .post("payroll/employeelist", data)
        .then((resp) => {
          if (
            get(resp, "data.result[0].employeelist", []).find(
              (x) => x.isdatagenerated,
            )
          ) {
            instance
              .post("payroll/getemployeebanksheetdetails", {
                payrollcycledurationid: get(
                  payrollcycle,
                  "payrollcycledurationid",
                  12,
                ),
                salarycyclesplitid: get(salarycycle, "displayvalue", 12),
                salarycycleid: get(salarycycle, "salarycycleid", 12),
                payrollyear: get(salarycycle, "payrollyear", 12),
                payrollmonthid: get(salarycycle, "payrollmonthid", 12),
                employeeids: get(resp, "data.result[0].employeelist", [])
                  .filter((x) => x.isdatagenerated)
                  .map((x) => x.employeeid),
              })
              .then((resp1) => {
                if (
                  get(resp1, "data.result", []) &&
                  get(resp1, "data.result", []).length > 0
                ) {
                  console.log("resp: ", resp1);
                  const headerobj = {
                    paymenttypecode: "PYMT_PROD_TYPE_CODE",
                    paymentmode: "PYMT_MODE",
                    debitaccnumber: "DEBIT_ACC_NO",
                    employeename: "BNF_NAME",
                    accountnumber: "BENE_ACC_NO",
                    ifsccode: "BENE_IFSC",
                    totalnetamount: "AMOUNT",
                    debitnarr: "DEBIT_NARR",
                    creditnarr: "CREDIT_NARR",
                    mobile: "MOBILE_NUM",
                    emailid: "EMAIL_ID",
                    remark: "REMARK",
                    paymentdate: "PYMT_DATE",
                    refno: "REF_NO",
                    addlinfo1: "ADDL_INFO1",
                    addlinfo2: "ADDL_INFO2",
                    addlinfo3: "ADDL_INFO3",
                    addlinfo4: "ADDL_INFO4",
                    addlinfo5: "ADDL_INFO5"
                  };

                  const allrows = [
                    headerobj,
                    ...resp1.data.result.flatMap(details => 
                      details.arrEmpDetails.map(emp => ({
                        paymenttypecode: details.paymenttypecode,
                        paymentmode: details.paymentmode,
                        debitaccnumber: details.debitaccnumber,
                        employeename: emp.employeename,
                        accountnumber: emp.accountnumber,
                        ifsccode: emp.ifsccode,
                        totalnetamount: emp.totalnetamount,
                        debitnarr: details.debitnarr,
                        creditnarr: details.creditnarr,
                        mobile: emp.mobile,
                        emailid: emp.emailid,
                        remark: details.remark,
                        paymentdate: details.paymentdate,
                        refno: details.refno,
                        addlinfo1: details.addlinfo1,
                        addlinfo2: details.addlinfo2,
                        addlinfo3: details.addlinfo3,
                        addlinfo4: details.addlinfo4,
                        addlinfo5: details.addlinfo5
                      }))
                    ),
                  ];
                  ExportArrearsXLSX1({
                    rows: allrows,
                    name: salarycycle && salarycycle.displayname,
                  });

                  const data = {
                    generationtypeid: 1,
                    reportcatagoryid: 4,
                    reporttypeid: 304,
                    reportfor: {
                      reportforlog: [
                        {
                          genaratefortypeid: 1,
                          genarateforids: null,
                          locationids: null,
                          stageids: "1,2,3,4,5,6,7,8",
                          reviewformids: null,
                          employmenttypeids: "1,2,3,4,5,6,7,8,9",
                        },
                      ],
                    },
                    fromdate: convertDateForBackend(
                      get(salarycycle, "cyclefrom", 12),
                    ),
                    todate: convertDateForBackend(
                      get(salarycycle, "cycleto", 12),
                    ),
                  };

                  instance.post("/reportrobo/reportrobolog", data);
                } else {
                  this.props.enqueueSnackbar("No record found", {
                    variant: "error",
                  });
                }
              })
              .catch((error) => {
                this.props.enqueueSnackbar(
                  error.response
                    ? error.response.data.error.message
                    : error.message,
                  { variant: "error" },
                );
              });
          } else {
            this.props.enqueueSnackbar("Bank data is not generated", {
              variant: "error",
            });
          }
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    } else {
      this.props.enqueueSnackbar("Please select atleast one option", {
        variant: "error",
      });
    }
  };

  generateslip = () => {
    const { salarycycle } = this.props;
    const { payrollcycledurationid } = this.props;
    const { selectedOptions, isSpeicalCase } = this.props;
    if (selectedOptions.length != 0) {
      this.setState({
        //ispayslipdrawer:true
      });
      const payrollgroup = this.getPayrollGroup();
      const data = {
        payrollcycledurationid,
        salarycycleid: salarycycle.salarycycleid,
        salarycyclesplitid: salarycycle.displayvalue,
        grouptypeid: isSpeicalCase
          ? selectedOptions[0] && selectedOptions[0].displayvalue
          : selectedOptions[0] && selectedOptions[0].displayvalue == 100
          ? selectedOptions[0] && selectedOptions[0].displayvalue
          : null,
        payrollgroup,
        payrollmonthid:
          this.props.salarycycle && this.props.salarycycle.payrollmonthid,
        payrollyear:
          this.props.salarycycle && this.props.salarycycle.payrollyear,
      };
      if (data.payrollgroup) {
        this.setState({ isgeneratepayslipdrawerloading: true }, () => {
          instance
            .post("payroll/employeelist", data)
            .then((resp) => {
              if (
                get(resp, "data.result[0].employeelist", []).find(
                  (x) => !x.ispayslipgenerated && x.isdatagenerated,
                )
              ) {
                this.setState({
                  employeelist: get(
                    resp,
                    "data.result[0].employeelist",
                    [],
                  ).filter((x) => !x.ispayslipgenerated && x.isdatagenerated),
                  tempdatalist: get(
                    resp,
                    "data.result[0].employeelist",
                    [],
                  ).filter((x) => !x.ispayslipgenerated && x.isdatagenerated),
                  open: true,
                  isgeneratepayslipdrawerloading: false,
                });
              } else {
                this.setState({ isgeneratepayslipdrawerloading: false });
                this.props.enqueueSnackbar(
                  `${
                    salarycycle.ispayrolldone && !isSpeicalCase
                      ? "Payslip is already generated for selected employees"
                      : "No record found"
                  }`,
                  { variant: "error" },
                );
              }
            })
            .catch((error) => {
              this.setState({ isgeneratepayslipdrawerloading: false });
              this.props.enqueueSnackbar(
                error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
            });
        });
      } else {
        this.setState({
          open: true,
        });
      }
    } else {
      this.props.enqueueSnackbar("Please select atleast one option", {
        variant: "error",
      });
    }
  };

  syncTaxsheet = () => {
    const { salarycycle } = this.props;
    const { payrollcycledurationid } = this.props;
    const { selectedOptions, isSpeicalCase } = this.props;
    if (selectedOptions.length != 0) {
      const payrollgroup = this.getPayrollGroup();
      const data = {
        payrollcycledurationid,
        salarycycleid: salarycycle.salarycycleid,
        salarycyclesplitid: salarycycle.displayvalue,
        grouptypeid: isSpeicalCase
          ? selectedOptions[0] && selectedOptions[0].displayvalue
          : selectedOptions[0] && selectedOptions[0].displayvalue == 100
          ? selectedOptions[0] && selectedOptions[0].displayvalue
          : null,
        payrollgroup,
        payrollmonthid:
          this.props.salarycycle && this.props.salarycycle.payrollmonthid,
        payrollyear:
          this.props.salarycycle && this.props.salarycycle.payrollyear,
      };
      // if (data.payrollgroup) {
      instance
        .post("payroll/employeelist", data)
        .then((resp) => {
          if (resp.data.result[0].employeelist.length > 0) {
            this.setState({
              newemployeelist: get(resp, "data.result[0].employeelist", []),
              backuplistdata: get(resp, "data.result[0].employeelist", []),
              taxsheetdata: true,
              tempdatalist:get(resp, "data.result[0].employeelist", []),
            });
          } else {
            this.props.enqueueSnackbar(`${"No record found"}`, {
              variant: "error",
            });
          }
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
      // } else {
      //   this.setState({
      //     taxsheetdata: true,
      //   });
      // }
    } else {
      this.props.enqueueSnackbar("Please select atleast one option", {
        variant: "error",
      });
    }
  };

  getPayslip = () => {
    const { salarycycle, payrollcycle } = this.props;
    const { employeelist } = this.state;
    const postdata = {
      payrollcycledurationid: get(payrollcycle, "payrollcycledurationid", 12),
      salarycycleid: get(salarycycle, "salarycycleid", 12),
      salarycyclesplitid: get(salarycycle, "displayvalue", 12),
      sentnotification: this.state.sentnotification,
      employeeids: employeelist
        .filter((x) => x.isexpanded)
        .map((x) => x.employeeid),
    };

    if (postdata.employeeids && postdata.employeeids.length > 0) {
      // this.finalgenerate(postdata);
      this.props.enqueueSnackbar(
        `You are about to generate payslip of ${postdata.employeeids.length} employees`,
        {
          variant: "warning",
          action: [
            <Button
              key="key"
              color="inherit"
              size="small"
              onClick={() => {
                const { issaveinprogress } = this.props.SaveInProgressReducer;
                console.log("issaveinprogress: ", issaveinprogress);
                if (!issaveinprogress) {
                  this.props.closeSnackbar();
                  instance
                    .post("payroll/generatesalaryslip", postdata)
                    .then(() => {
                      this.props.enqueueSnackbar(
                        "Salary slip generated successfully",
                        {
                          variant: "success",
                        },
                      );
                      this.props.getsalarycycledata();
                      this.setState({
                        open: false,
                        sentnotification: false,
                      });
                      this.props.removeSaveProgress();
                    })
                    .catch((error) => {
                      this.props.removeSaveProgress();
                      this.props.enqueueSnackbar(
                        error.response
                          ? error.response.data.error.message
                          : error.message,
                        { variant: "error" },
                      );
                    });
                }
              }}
            >
              Yes
            </Button>,
            <Button
              key="key"
              color="inherit"
              size="small"
              onClick={() => this.props.closeSnackbar()}
            >
              No
            </Button>,
          ],
        },
      );
    } else {
      this.props.enqueueSnackbar("Please select atleast one employee", {
        variant: "error",
      });
    }
  };

  render() {
    const {
      generatedBoth,
      finalEmployeeList = [],
      employeelist = [],
      searchValue = "",
    } = this.state;

    const {
      selectedOptions = [],
      selectedEmployees = [],
      updateSelection,
      filterOptions,
      isSpeicalCase,
    } = this.props;
    console.log("selectedOptions: ", this.props.selectedOptions);

    const showempselection =
      selectedOptions && selectedOptions.find((x) => x.grouptypeid === 0);
    const filteremp = finalEmployeeList.filter(
      (x) =>
        !searchValue ||
        (searchValue &&
          x.empfullname.toLowerCase().search(searchValue.toLowerCase()) !== -1),
    );
    const filteremp1 = employeelist.filter(
      (x) =>
        !searchValue ||
        (searchValue &&
          x.empfullname.toLowerCase().search(searchValue.toLowerCase()) !== -1),
    );
    return (
      <div className="margin-top-16">
        <p className="normal-dark-secondary margin-bottom-24">
          Welcome to your run payroll dashboard, you can generate payroll data
          along with salary slips for all your employees, all in a few clicks.
          ⚡️
        </p>
        <div>
          <div className="floatleft width60">
            {isSpeicalCase ? (
              <DynamicForm
                fields={selectinputconverter({
                  label: "For whom would you like to run payroll?",
                  options: filterOptions[0].options,
                  value: selectedOptions[0]
                    ? selectedOptions[0].displayvalue
                    : null,
                })}
                onChange={(val) => {
                  console.log("filterOptions[0]: ", filterOptions[0]);
                  const obj = filterOptions[0].options.find(
                    (x) => x.displayvalue == val,
                  );
                  updateSelection({
                    selectedOptions: [obj] || [],
                    selectedEmployees: [],
                    selectedBus: [],
                    selectedDep: [],
                    selectedEmpType: [],
                    selectedLoc: [],
                  });
                }}
              />
            ) : (
              <DynamicForm
                fields={multiselectinputconverter({
                  label: "For whom would you like to run payroll?",
                  options: filterOptions,
                  value: selectedOptions,
                })}
                onChange={(val) => {
                  const obj = val.find((x) => x.grouptypeid == 0);
                  const fnfobj = val.find((x) => x.grouptypeid == 100);
                  const allobj = val.find((x) => x.grouptypeid == 1);
                  if (selectedOptions.find((x) => x.grouptypeid == 0)) {
                    val = val.filter((x) => x.grouptypeid != 1);
                  } else if (selectedOptions.find((x) => x.grouptypeid == 1)) {
                    // val = [
                    //   {
                    //     displayvalue: 1,
                    //     displayname: "All employees",
                    //     grouptypeid: 1,
                    //   },
                    // ];
                    val = val.filter((x) => x.grouptypeid == 1);
                  }

                  updateSelection({
                    selectedOptions: fnfobj
                      ? [
                          {
                            displayvalue: "100",
                            displayname: "FNF employees",
                            grouptypeid: 100,
                          },
                        ]
                      : obj
                      ? [
                          {
                            displayvalue: 0,
                            displayname: "Specific employees",
                            grouptypeid: 0,
                          },
                        ]
                      : allobj
                      ? [
                          {
                            displayvalue: 1,
                            displayname: "All employees",
                            grouptypeid: 1,
                          },
                        ]
                      : val.filter((x) => x.grouptypeid != 0) || [],
                    selectedEmployees:
                      fnfobj || allobj
                        ? []
                        : !obj
                        ? []
                        : val.find((x) => x.grouptypeid === 0)
                        ? selectedEmployees
                        : [],
                    selectedBus:
                      fnfobj || allobj
                        ? []
                        : obj
                        ? []
                        : val.filter((x) => x.grouptypeid === 2)
                        ? val.filter((x) => x.grouptypeid === 2)
                        : [],
                    selectedDep:
                      fnfobj || allobj
                        ? []
                        : obj
                        ? []
                        : val.filter((x) => x.grouptypeid === 3)
                        ? val.filter((x) => x.grouptypeid === 3)
                        : [],
                    selectedEmpType:
                      fnfobj || allobj
                        ? []
                        : obj
                        ? []
                        : val.filter((x) => x.grouptypeid === 4)
                        ? val.filter((x) => x.grouptypeid === 4)
                        : [],
                    selectedLoc:
                      fnfobj || allobj
                        ? []
                        : obj
                        ? []
                        : val.filter((x) => x.grouptypeid === 5)
                        ? val.filter((x) => x.grouptypeid === 5)
                        : [],
                  });
                }}
              />
            )}
          </div>
          {selectedOptions && selectedOptions.length > 0 && (
            <div
              className="floatleft margin-left-8 cursor-pointer"
              style={{ paddingTop: 18 }}
              onClick={this.addSignatoryDrawer}
            >
              <IconWithBackground imgsrc={previewIcon} />
            </div>
          )}
        </div>
        {showempselection && (
          <div className="clearfloat">
            <Select
              className="selectsearch margin-top-100 width60"
              // onInputChange={this.SearchEmployee}
              onChange={this.setSelectedEmployees}
              isMulti
              options={this.props.empList}
              getOptionLabel={(option) => option.displayname}
              getOptionValue={(option) => option.displayvalue}
              value={selectedEmployees || []}
              placeholder="Enter employee name"
            />
          </div>
        )}

        <p className="small-dark-secondary clear-float margin-top-20">
          {generatedBoth
            ? "Almost done here, we just have to generate salary slips for the selected employees!"
            : "Great, let’s start by generating payroll data for the selected employees. "}
        </p>

        {generatedBoth && (
          <p className="small-blue t-bold margin-top-16">
            I want to revise payroll data for these groups
          </p>
        )}

        <div className="width100">
          <div>
            <div className="floatleft" style={{ marginLeft: 172 }}>
              <div
                className="width100"
                style={{
                  position: "fixed",
                  left: 0,
                  background: "white",
                  bottom: 0,
                  padding: 10,
                  borderTop: "1px solid #d4d4d4",
                  zIndex: 1,
                }}
              >
                <div>
                  <div className="floatleft" style={{ marginLeft: 128 }}>
                    {this.props.selectedOptions &&
                      this.props.selectedOptions.length > 0 && (
                        <Button
                          className="btn btn-secondary-md-blue margin-right-8"
                          variant="contained"
                          onClick={() =>
                            this.setState({
                              banksheetdrawer: true,
                            })
                          }
                        >
                          Bank sheet
                        </Button>
                      )}
                    {this.props.selectedOptions &&
                      this.props.selectedOptions.length > 0 && (
                        <Button
                          className="btn btn-primary-md-blue margin-right-8"
                          variant="contained"
                          onClick={this.generateslip}
                        >
                          Generate payslip
                        </Button>
                      )}
                    {this.props.selectedOptions &&
                      this.props.selectedOptions.length > 0 && (
                        <Button
                          className="btn btn-primary-md-blue margin-right-8"
                          variant="contained"
                          onClick={this.syncTaxsheet}
                        >
                          Sync Tax Sheet
                        </Button>
                      )}
                  </div>
                  <div className="floatright" style={{ marginRight: 72 }}>
                    {this.props.salarycycle && (
                      <div>
                        <Button
                          className="btn btn-primary-md-blue xx"
                          variant="contained"
                          onClick={this.ongeneratepayrollclick}
                        >
                          Generate payroll data
                        </Button>
                      </div>
                    )}
                  </div>
                  <div className="clearfloat"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Drawer
          anchor="right"
          open={this.state.open}
          onClose={() =>
            this.setState({
              open: false,
              isgenerate: false,
              searchValue: "",
              selecteddatatypeid: "1",
              datatypeid: {
                displayvalue: "1",
                displayname: "All",
              },
              //ispayslipdrawer:false
            })
          }
          style={{ padding: 40 }}
          classes={{
            paper: "planner-drawer padding15 width25",
          }}
        >
          <div>
            {!this.state.isgenerate ? (
              <div className="position-rel" style={{ height: "100vh" }}>
                <DrawerHeader
                  header={`Generate payslip of ${employeelist.length} employee(s)`}
                  isbackarrow={false}
                  closeDrawer={() =>
                    this.setState({
                      open: false,
                      searchValue: "",
                      isgenerate: false,
                      selecteddatatypeid: "1",
                                datatypeid: {
                                  displayvalue: "1",
                                  displayname: "All",
                                },
                      //  ispayslipdrawer:false
                    })
                  }
                />

                <SearchSq
                  placeholder="Search employees..."
                  value={this.state.searchValue}
                  onChange={(e) => {
                    this.setState({
                      searchValue: e.target.value || "",
                    });
                  }}
                />
                <p className="normal-dark-secondary margin-bottom-8 margin-top-8">
                  Select employees to generate payslip.
                </p>

                <div>
                  <div
                    className="display-flex"
                    style={{ height: 36, justifyContent: "space-between" }}
                  >
                    <div className="display-flex">
                      <div
                        className="floatleft margin-right-8"
                        style={{ paddingTop: 3, marginLeft: 4 }}
                      >
                        <div className={"padding-left-4"}>
                          {filteremp1.length > 0 && (
                            <DynamicForm
                              fields={checkboxinputconverter({
                                value:
                                  employeelist.length ==
                                  employeelist.filter((x) => x.isexpanded)
                                    .length
                                    ? true
                                    : false,
                              })}
                              onChange={() => {
                                const temp = employeelist.map((x) => ({
                                  ...x,
                                  isexpanded: employeelist.find(
                                    (x1) => !x1.isexpanded,
                                  )
                                    ? true
                                    : false,
                                }));
                                this.setState({
                                  employeelist: employeelist.map((x) => {
                                    const obj = temp.find(
                                      (x1) => x1.employeeid == x.employeeid,
                                    );
                                    if (obj) {
                                      return obj;
                                    } else {
                                      return x;
                                    }
                                  }),
                                });
                              }}
                            />
                          )}
                        </div>
                      </div>
                      {filteremp1.length > 0 && (
                        <p style={{ marginTop: 5, fontWeight: "bold" }}>
                          Select all
                        </p>
                      )}
                    </div>
                   
                  </div>

                  <div
                    className="margin-top-16 padding-bottom-16 thin-scroll p1"
                    style={{ overflowY: "auto", height: "calc(95vh - 250px)" }}
                  >
                    {employeelist &&
                      filteremp1
                        .filter((x) => !x.ispayslipgenerated)
                        .map((emp, index) => (
                          <div
                            style={{
                              background: "#f7f8f8",
                              borderBottom: "1px dashed #979797",
                              padding: "8px 8px",
                              display: "flex",
                            }}
                          >
                            <div
                              className="margin-right-8"
                              style={{ height: 24 }}
                            >
                              <DynamicForm
                                fields={checkboxinputconverter({
                                  value: emp.isexpanded,
                                })}
                                onChange={() => {
                                  const temp = employeelist;
                                  const tempindex = temp.findIndex(
                                    (x) => x.employeeid == emp.employeeid,
                                  );
                                  temp[tempindex].isexpanded = !emp.isexpanded;
                                  this.setState({
                                    employeelist: temp,
                                  });
                                }}
                              />
                            </div>
                            <div className="width90">
                              <p className="small-blue t-bold width100 ellipsis">
                                {emp.empfullname}
                              </p>
                              <div
                                className="display-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <p className="small-dark-secondary width70 ellipsis">
                                  {emp.designation}
                                </p>
                               
                              </div>
                            </div>
                            <div className="clear-float"></div>
                          </div>
                        ))}
                  </div>
                  <div
                    className="margin-top-16"
                    style={{
                      position: "absolute",
                      bottom: 16,
                      background: "#fff",
                      boxShadow: "0px 3px 4px #ddd",
                      width: "100%",
                      padding: "8px 15px",
                      margin: "0px 0px",
                      left: 0,
                      marginLeft: -15,
                      display: "flex",
                    }}
                  >
                    <DynamicForm
                      fields={checkboxinputconverter({
                        value: this.state.sentnotification,
                        placeholder: "",
                        label: "Notify employee",
                      })}
                      onChange={() =>
                        this.setState({
                          sentnotification: !this.state.sentnotification,
                        })
                      }
                    />
                    <Button
                      className="btn btn-primary-md-blue"
                      variant="contained"
                      disabled={
                        this.props.SaveInProgressReducer.issaveinprogress
                      }
                      onClick={this.getPayslip}
                    >
                      Generate
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="position-rel" style={{ height: "100vh" }}>
                <DrawerHeader
                  header={`Generate payroll data of ${finalEmployeeList.length} employee(s)`}
                  isbackarrow={false}
                  closeDrawer={() =>
                    this.setState({
                      open: false,
                      isgenerate: "",
                      searchValue: "",
                      selecteddatatypeid: "1",
                                datatypeid: {
                                  displayvalue: "1",
                                  displayname: "All",
                                },
                    })
                  }
                />
                {
                  <p className="normal-dark-secondary margin-bottom-8 margin-top-8">
                    Select employees to generate payroll data.
                  </p>
                }
                <SearchSq
                  placeholder="Search employees..."
                  value={this.state.searchValue}
                  onChange={(e) => {
                    this.setState({
                      searchValue: e.target.value || "",
                    });
                  }}
                />

                <div>
                  <div
                    className="display-flex margin-top-8"
                    style={{ height: 36, justifyContent: "space-between" }}
                  >
                    <div className="display-flex">
                      <div
                        className="margin-right-8"
                        style={{ paddingTop: 3, marginLeft: 8 }}
                      >
                        {filteremp.length > 0 && (
                          <DynamicForm
                            fields={checkboxinputconverter({
                              value:
                                finalEmployeeList.length ==
                                finalEmployeeList.filter((x) => x.isexpanded)
                                  .length
                                  ? true
                                  : false,
                            })}
                            onChange={() => {
                              const temp = finalEmployeeList.map((x) => ({
                                ...x,
                                isexpanded: finalEmployeeList.find(
                                  (x1) => !x1.isexpanded,
                                )
                                  ? true
                                  : false,
                              }));
                              this.setState({
                                finalEmployeeList: finalEmployeeList.map(
                                  (x) => {
                                    const obj = temp.find(
                                      (x1) => x1.employeeid == x.employeeid,
                                    );
                                    if (obj) {
                                      return obj;
                                    } else {
                                      return x;
                                    }
                                  },
                                ),
                              });
                            }}
                          />
                        )}
                      </div>
                      {filteremp.length > 0 && (
                        <p style={{ marginTop: 5, fontWeight: "bold" }}>
                          Select all
                        </p>
                      )}
                    </div>

                    <div style={{ width: 218 }}>
                      <Select
                        className={"selectsearch"}
                        onChange={this.handleChange1.bind(this)}
                        options={this.state.datacategories}
                        getOptionLabel={(option) => option.displayname}
                        getOptionValue={(option) => option.displayvalue}
                        value={this.state.datatypeid}
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div
                    className="margin-top-16 thin-scroll"
                    style={{ overflowY: "auto", height: "calc(95vh - 282px)" }}
                  >
                    {finalEmployeeList &&
                      filteremp
                        .filter((x) => !x.ispayslipgenerated)
                        .map((emp) => (
                          <div
                            style={{
                              background: "#f7f8f8",
                              borderBottom: "1px dashed #979797",
                              padding: "8px 8px",
                              display: "flex",
                            }}
                          >
                            <div
                              className=" margin-right-8"
                              style={{ height: 24 }}
                            >
                              <DynamicForm
                                fields={checkboxinputconverter({
                                  value: emp.isexpanded,
                                })}
                                onChange={() => {
                                  const temp = [...finalEmployeeList];
                                  const tempindex = finalEmployeeList.findIndex(
                                    (x) => x.employeeid == emp.employeeid,
                                  );
                                  temp[tempindex].isexpanded = !emp.isexpanded;
                                  this.setState({
                                    finalEmployeeList: temp,
                                  });
                                }}
                              />
                            </div>
                            <div className=" width90">
                              <p className="small-blue t-bold width100 ellipsis">
                                {emp.empfullname}
                              </p>
                              <div
                                className="display-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <p className="small-dark-secondary width70 ellipsis">
                                  {emp.designation}
                                </p>
                                {emp.isdatagenerated && (
                                  <p
                                    style={{
                                      background: "#dcf2f1",
                                      fontSize: 11,
                                      padding: "2px 8px",
                                      color: "008985",
                                      borderRadius: 8,
                                      marginTop: 0,
                                      marginBottom: 0,
                                    }}
                                  >
                                    Data generated
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="clear-float"></div>
                          </div>
                        ))}
                  </div>
                  <div
                    className="margin-top-16"
                    style={{
                      position: "absolute",
                      bottom: 16,
                      background: "#fff",
                      boxShadow: "0px 3px 4px #ddd",
                      width: "calc(100% + 30px)",
                      padding: "8px 15px",
                      margin: "0px 0px",
                      left: 0,
                      marginLeft: -15,
                    }}
                  >
                    <Button
                      className="btn btn-primary-md-blue"
                      variant="contained"
                      onClick={() => {
                        const temp = this.state.finalEmployeeList.filter(
                          (x1) => x1.isexpanded,
                        );
                        this.ongeneratepayrollclick(temp);
                      }}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Drawer>
        <Drawer
          anchor="right"
          open={this.state.SignatoryDrawer}
          onClose={this.CloseSignatoryDrawer}
          style={{ padding: 40 }}
          classes={{
            paper: "planner-drawer padding15 width25",
          }}
        >
          <div>
            <DrawerHeader
              header={`Selected employees (${
                finalEmployeeList && finalEmployeeList.length
              })`}
              isbackarrow={false}
              closeDrawer={this.CloseSignatoryDrawer}
            />
            {/* <SearchSq
              placeholder="Search employees..."
              // value={this.state.searchValue}
              // onChange={this.onSearch}
              // className="margin-bottom-8"
            /> */}
            {/* <div className="margin-top-8 margin-bottom-8">
              <div className="floatleft">
                <Switch
                  checked={islwfdeduction}
                  onChange={(val) =>
                    this.setState({
                      postdata: { islwfdeduction: val.target.checked },
                    })
                  }
                  value={islwfdeduction}
                  color="primary"
                />
              </div>
              <p className="floatleft small-dark-secondary padding-top-10">
                Only omitted employees with payroll run
              </p>
            </div> */}
            {this.state.isloading ? (
              <img className="loader" src={loader} />
            ) : (
              <div>
                <SearchSq
                  placeholder="Search employees..."
                  value={this.state.searchemployeeValue}
                  onChange={(e) => this.handleStructureSearch(e)}
                />
                <div
                  className="thin-scroll margin-top-16"
                  style={{ overflowY: "auto", height: "calc(90vh - 88px)" }}
                >
                  {finalEmployeeList &&
                    finalEmployeeList.map((emp) => (
                      <div
                        style={{
                          background: "#f7f8f8",
                          borderBottom: "1px dashed #979797",
                          padding: "8px 8px",
                          display: "flex",
                        }}
                      >
                        <div
                          className=" margin-right-8"
                          style={{ paddingTop: 3 }}
                        >
                          {/* <div className="padding-left-4 checkbox-div">
                        <DynamicForm
                          fields={checkboxinputconverter({
                            value: false,
                          })}
                          onChange={() => {}}
                        />
                      </div> */}
                          <div>
                            <ProfilePictureSmall src={DefaultProfileImage} />
                          </div>
                        </div>
                        <div className=" width90">
                          <p className="small-blue t-bold width100 ellipsis">
                            {emp.empfullname}
                          </p>
                          <div
                            className="display-flex"
                            style={{ justifyContent: "space-between" }}
                          >
                            <p className="small-dark-secondary width70 ellipsis">
                              {emp.designation}
                            </p>
                            {emp.isdatagenerated && (
                              <p
                                style={{
                                  background: "#dcf2f1",
                                  fontSize: 11,
                                  padding: "2px 8px",
                                  color: "008985",
                                  borderRadius: 8,
                                  marginTop: 0,
                                  marginBottom: 0,
                                }}
                              >
                                Data generated
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="clear-float"></div>
                      </div>
                    ))}
                </div>
              </div>
            )}

            {/* <div className="payroll-list-footer-btn">
              <Button
                variant="contained"
                className="btn btn-primary-md-yellow margin-left-12 margin-top-12 margin-bottom-12"
                color="primary"
                disabled={true}
                // onClick={this.props.onCancel}
              >
                Postpone payroll
              </Button>
            </div> */}
          </div>
        </Drawer>
        <Drawer
          anchor="right"
          open={this.state.taxsheetdata}
         // onClose={this.CloseSignatoryDrawer}
          onClose={() =>
            this.setState({
              taxsheetdata: false,
              open: false,
             
            })
          }
          style={{ padding: 40 }}
          classes={{
            paper: "planner-drawer padding15 width25",
          }}
        >
          <div>
            <DrawerHeader
              header={`Selected employees (${
                this.state.newemployeelist && this.state.newemployeelist.length
              })`}
              isbackarrow={false}
              closeDrawer={() =>
                this.setState({
                  taxsheetdata: false,
                  open: false,
                  
                })
              }
            />
            {/* <SearchSq
              placeholder="Search employees..."
              // value={this.state.searchValue}
              // onChange={this.onSearch}
              // className="margin-bottom-8"
            /> */}
            {/* <div className="margin-top-8 margin-bottom-8">
              <div className="floatleft">
                <Switch
                  checked={islwfdeduction}
                  onChange={(val) =>
                    this.setState({
                      postdata: { islwfdeduction: val.target.checked },
                    })
                  }
                  value={islwfdeduction}
                  color="primary"
                />
              </div>
              <p className="floatleft small-dark-secondary padding-top-10">
                Only omitted employees with payroll run
              </p>
            </div> */}

            <SearchSq
              placeholder="Search employees..."
              value={this.state.searchemployeeValue}
              onChange={(e) => this.handleStructureSearch(e)}
            />
            <div
              className="thin-scroll margin-top-16"
              style={{ overflowY: "auto", height: "calc(100vh - 188px)" }}
            >
 

              {this.state.newemployeelist &&
                this.state.newemployeelist.map((emp) => (
                  <div
                    style={{
                      background: "#f7f8f8",
                      borderBottom: "1px dashed #979797",
                      padding: "8px 8px",
                      display: "flex",
                    }}
                  >
                    <div className="margin-right-8" style={{ height: 24 }}>
                      <DynamicForm
                        fields={checkboxinputconverter({
                          value: emp.isexpanded,
                        })}
                        onChange={() => {
                          const temp = [...this.state.newemployeelist];
                          const y = temp.filter(
                            (x) => x.isexpanded && x.isexpanded == true,
                          );
                          if (y.length < 20) {
                            const tempindex =
                              this.state.newemployeelist.findIndex(
                                (x) => x.employeeid == emp.employeeid,
                              );
                            temp[tempindex].isexpanded = !emp.isexpanded;
                            this.setState({
                              newemployeelist: temp,
                            });
                          } else {
                            this.props.enqueueSnackbar(
                              "You can select a maximum of 20 employees to re-run the tax sheet.",
                              {
                                variant: "error",
                              },
                            );
                          }
                        }}
                      />
                    </div>
                    <div className=" width90">
                      <p className="small-blue t-bold width100 ellipsis">
                        {emp.empfullname}
                      </p>
                      <div
                        className="display-flex"
                        style={{ justifyContent: "space-between" }}
                      >
                        <p className="small-dark-secondary width70 ellipsis">
                          {emp.designation}
                        </p>
                        {emp.isdatagenerated && (
                          <p
                            style={{
                              background: "#dcf2f1",
                              fontSize: 11,
                              padding: "2px 8px",
                              color: "008985",
                              borderRadius: 8,
                              marginTop: 0,
                              marginBottom: 0,
                            }}
                          >
                            Data generated
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="clear-float"></div>
                  </div>
                ))}
            </div>
            <div
              className="margin-top-16"
              style={{
                position: "absolute",
                bottom: 30,
                background: "#fff",
                boxShadow: "0px 3px 4px #ddd",
                width: "100%",
                padding: "8px 0px",

                left: 0,
              }}
            >
              <Button
                className="btn btn-primary-md-blue margin-left-16"
                variant="contained"
                onClick={() => {
                  console.log("newemployeelist: ", this.state.newemployeelist);
                  const temp = this.state.newemployeelist.filter(
                    (x1) => x1.isexpanded,
                  );
                  console.log("temp: ", temp);
                  this.onSyncSheet(temp);
                }}
                disabled={this.props.SaveInProgressReducer.issaveinprogress}
              >
                Sync Tax Sheet
              </Button>
            </div>

            {/* <div className="payroll-list-footer-btn">
              <Button
                variant="contained"
                className="btn btn-primary-md-yellow margin-left-12 margin-top-12 margin-bottom-12"
                color="primary"
                disabled={true}
                // onClick={this.props.onCancel}
              >
                Postpone payroll
              </Button>
            </div> */}
          </div>
        </Drawer>
        <Drawer
          anchor="right"
          open={this.state.banksheetdrawer}
          onClose={() => this.setState({ banksheetdrawer: false })}
          style={{ padding: 40 }}
          classes={{
            paper: "planner-drawer padding15 width30",
          }}
        >
          <div className="position-rel" style={{ height: "100vh" }}>
            <DrawerHeader
              header="Download Bank Sheet"
              isbackarrow={false}
              closeDrawer={() => this.setState({ banksheetdrawer: false })}
            />
            <div style={{}}>
              <Paper className="padding16 margin-bottom-16 rounded-rectangle-paper">
                <div className="floatleft">
                  <img src={bankillustration} className="floatleft" />
                  <p
                    className="large-text-dark paddin-left-16 margin-left-24 padding-top-4"
                    style={{ paddingLeft: 16 }}
                  >
                    Default bank sheet
                  </p>
                </div>
                <div className="clear-float"></div>
                <p className="small-dark-secondary margin-top-16">
                  Get a generic bank sheet that works for most banks by clicking
                  on the download button below.
                </p>
                <Button
                  className="btn btn-primary-md-blue margin-top-16 "
                  variant="contained"
                  onClick={this.download}
                  style={{ fontSize: 14 }}
                >
                  Download
                </Button>
              </Paper>
              <Paper className="padding16 margin-bottom-16 rounded-rectangle-paper">
                <img
                  src={IciciIcon}
                  // className="height100 width100"
                />
                <p
                  className="
small-dark-secondary margin-top-16"
                >
                  Download and use this bank sheet if your company's salary is
                  processed via ICICI Bank.
                </p>
                <Button
                  className="btn btn-primary-md-blue margin-top-16 "
                  variant="contained"
                  onClick={this.downloadIcci}
                  // startIcon={<DeleteIcon />}
                  style={{ fontSize: 14 }}
                >
                  Download
                </Button>
              </Paper>
            </div>
          </div>
        </Drawer>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={this.state.isloading}
          // onClose={() => this.setState({ openDialog: false, empform1: null })}
          aria-labelledby="max-width-dialog-title"
          classes={{
            scrollPaper: "no-shadow bg-transparent",
            paper: "no-shadow bg-transparent",
          }}
        >
          <img className="loader" src={loader} />
        </Dialog>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={this.state.isgeneratedrawerloading}
          // onClose={() => this.setState({ openDialog: false, empform1: null })}
          aria-labelledby="max-width-dialog-title"
          classes={{
            scrollPaper: "no-shadow bg-transparent",
            paper: "no-shadow bg-transparent",
          }}
        >
          <img className="loader" src={loader} />
        </Dialog>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={this.state.isgeneratepayslipdrawerloading}
          // onClose={() => this.setState({ openDialog: false, empform1: null })}
          aria-labelledby="max-width-dialog-title"
          classes={{
            scrollPaper: "no-shadow bg-transparent",
            paper: "no-shadow bg-transparent",
          }}
        >
          <img className="loader" src={loader} />
        </Dialog>

        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={this.state.loading}
          // onClose={() => this.setState({ openDialog: false, empform1: null })}
          aria-labelledby="max-width-dialog-title"
          classes={{
            scrollPaper: "no-shadow bg-transparent",
            paper: "no-shadow bg-transparent",
          }}
        >
          <DialogContent>
            <div
              className="progess-wrapper"
              style={{
                position: "relative",
                width: 120,
                height: 120,
                margin: "0 auto",
                color: "#fff",
              }}
            >
              <CircularProgress
                className="goal-progress"
                variant="static"
                size={100}
                value={parseInt(this.state.time)}
                color="inherit"
              />
              <div
                className="progress-line"
                style={{ borderColor: "#fff" }}
              ></div>
              <div
                className="vertical-center text-center"
                style={{ height: 30 }}
              >
                <span
                  style={{
                    display: "block",
                    fontSize: 24,
                    color: "#fff",
                    fontWeight: "bold",
                  }}
                >
                  {this.state.time}%
                </span>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  // login: state.AuthenticationAction.login,
  // Language: state.LanguageAction.Language,
  // SubscriptionInfo: state.SubscriptionInfo,
  SaveInProgressReducer: state.SaveInProgressReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setSaveProgress,
      removeSaveProgress,
      // SetRequestCenter,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(RunPayrollTab)));
